import React, { PropsWithChildren } from "react";
import { ModalContent, BoxProps } from "@chakra-ui/react";
import { ScrollShadowIndicator } from "src/components/modals/scroll-indicator/scroll-shadow-indicator";

interface IModalContentWrapper extends BoxProps {}

export const ModalContentWrapper = ({ children }: PropsWithChildren<IModalContentWrapper>) => {
    return (
        <ModalContent maxW={["full", "688px", "708px", "708px"]} position="relative" overflow="hidden">
            <ScrollShadowIndicator> {children}</ScrollShadowIndicator>
        </ModalContent>
    );
};
